// extracted by mini-css-extract-plugin
export default {"btn":"ThumbnailButton_btn__uVRUm"};